import React from 'react';
import {
  CheckboxLabelContainer,
  CheckboxContainer,
  CheckboxInput,
  CheckboxMark,
  CheckboxLabel,
  CheckboxAdditionalLabel
} from './styled';
import { CheckboxProps } from './types';

const LONG_NAME_SYMBOLS = 40;

export const Checkbox = ({
  name,
  stat,
  cypress,
  currentValues,
  onChangeHandler,
  label,
  additionalLabel,
  id,
  labelClass,
  markAlign = 'right',
  isGroupCheckbox = false,
  isChecked = false
}: CheckboxProps) => {
  const isLongName = label.length > LONG_NAME_SYMBOLS;

  return (
    <CheckboxLabelContainer data-stat={stat} isLongName={isLongName}>
      <CheckboxContainer
        data-cy="search-checkbox-container"
        className={labelClass}
        markAlign={markAlign}
        isLongName={isLongName}
      >
        <CheckboxInput
          value={id}
          name={name}
          type="checkbox"
          id={`location_ids_${id}`}
          onChange={onChangeHandler}
          data-cy={`${cypress}-${id}`}
          checked={currentValues?.includes(id) || isChecked}
        />
        <div>
          <CheckboxLabel
            $isGroupCheckbox={isGroupCheckbox}
            data-cy={`${cypress}-name`}
            tag={isGroupCheckbox ? 'title_6' : 'body_1'}
          >
            {label}
          </CheckboxLabel>
          {additionalLabel && (
            <CheckboxAdditionalLabel tag="body_2">
              {`(${additionalLabel})`}
            </CheckboxAdditionalLabel>
          )}
        </div>
        <CheckboxMark data-cy="checkbox-mark" />
      </CheckboxContainer>
    </CheckboxLabelContainer>
  );
};
